function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Icon } from '../../../../components/icon';
export var IconSuccessCircle = props => {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 20 20",
    width: "100%",
    height: "100%"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "success-circle",
    cx: "10",
    cy: "10",
    r: "10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "success-circle-path",
    d: "M8.472 0l-5 4.922-1.943-1.913L0 4.513l3.472 3.418L10 1.504z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "success-circle-mask",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#success-circle"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#019e1e",
    xlinkHref: "#success-circle"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#success-circle-mask)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 6.034)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M8.472 0l-5 4.922-1.943-1.913L0 4.513l3.472 3.418L10 1.504z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "success-circle-mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#success-circle-path"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    mask: "url(#success-circle-mask-2)",
    d: "M0 0h10v7.931H0z"
  })))));
};